import { defineStore } from "pinia";

// Single FE source for everything per-role: label, badge icon, badge
// color, avatar URL. The backend (AiAgent::TYPE_CATALOG) is the source
// of truth; this store fetches the list once and caches it for every
// consumer (avatar component, create form, etc.) so the keys don't
// drift between PHP and Vue.
export const useAiAgentTypeCatalogStore = defineStore("fanweb-ai-agent-type-catalog-store", {
  state: () => ({
    agentTypes: [],
    isLoading: false,
    isLoaded: false,
  }),
  getters: {
    // Look up a single role by its agent_type value. Returns null when
    // the catalog hasn't loaded yet or the value isn't recognised — the
    // avatar / form components decide their own fallback in that case.
    entryForType: state => value => state.agentTypes.find(entry => entry.value === value) || null,
  },
  actions: {
    loadCatalogIfNeeded(onComplete) {
      if (this.isLoaded || this.isLoading) {
        onComplete?.(this.agentTypes);
        return;
      }
      this.isLoading = true;
      this.apiGet("/ai-agent/types/catalog",
        {},
        response => {
          this.agentTypes = Array.isArray(response) ? response : [];
          this.isLoaded = true;
          this.isLoading = false;
          onComplete?.(this.agentTypes);
        },
        () => {
          this.isLoading = false;
          onComplete?.([]);
        });
    },
  },
});
